import { Quote } from 'Cube/domain/cube.domain.types'
import { AmendableSchedule } from './useAmendableSchedules'

/**
 * Stands in for the backend's snapshot of the amended schedule until the next
 * reload brings back the real one. Like the backend's, discounts and minimums
 * point at products rather than prices.
 */
export const scheduleToAmendmentSnapshot = (
  schedule: AmendableSchedule
): NonNullable<Quote['amendment']>['original'] => ({
  phases: schedule.phases.map(phase => ({
    startDate: phase.startDate,
    // Open-ended phases come back with an empty end date
    endDate: phase.endDate || undefined,
    prices: pricesWithIds(schedule, phase.priceIds).map(price => ({
      productId: price.productId,
      name: price.name,
      structure: price.structure,
      billingFrequency: price.billingFrequency,
      billingType: price.billingType,
      customMetricParameters: price.customMetricParameters,
      usageCalculationPeriod: price.usageCalculationPeriod
    })),
    discounts: phase.discounts.map(discount => ({
      discountCalculationType: discount.type,
      amount: String(discount.amount),
      message: discount.message,
      seatDiscountType: discount.seatDiscountType,
      productIds: productIdsOf(schedule, discount.restrictToPrices)
    })),
    minimums: phase.minimums.map(minimum => ({
      amount: String(minimum.amount),
      productIds: productIdsOf(schedule, minimum.restrictToPrices)
    }))
  }))
})

const pricesWithIds = (schedule: AmendableSchedule, priceIds: string[]) =>
  schedule.prices.filter(price => priceIds.includes(price.id))

const productIdsOf = (schedule: AmendableSchedule, priceIds: string[]) =>
  pricesWithIds(schedule, priceIds).map(price => price.productId)
